import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { DefaultSeo as NextDefaultSeo } from "next-seo";
import { ConfigConsumer } from "../modules/Config/ConfigContext";
export const DEFAULT_SEO = {
    title: "The Parks Channel",
    titleTemplate: "The Parks Channel",
    defaultTitle: "The Parks Channel",
    description: "At Parks Channel, our mission is to become a destination platform for “America’s Best Idea” – at home, on the journey and for making memories. We want to make it easier to discover amazing places and then actually go there. We want to tell stories that entertain and inform. We want to build a community of content creators who inspire others through their journeys. The Parks Channel is deeply committed to the mission of protecting and enhancing the park experience.",
    openGraph: {
        title: "The Parks Channel",
        url: undefined,
        description: "At Parks Channel, our mission is to become a destination platform for “America’s Best Idea” – at home, on the journey and for making memories. We want to make it easier to discover amazing places and then actually go there. We want to tell stories that entertain and inform. We want to build a community of content creators who inspire others through their journeys. The Parks Channel is deeply committed to the mission of protecting and enhancing the park experience.",
        images: [
            {
                width: 500,
                height: 261,
                url: undefined,
                alt: "The Parks Channel"
            }
        ]
    },
    twitter: {
        handle: "@TheParksChannel",
        cardType: "summary_large_image"
    }
};
export const DefaultSeo = ()=>{
    return /*#__PURE__*/ _jsx(ConfigConsumer, {
        children: (param)=>/*#__PURE__*/ {
            let { pageUrl  } = param;
            return _jsx(NextDefaultSeo, {
                ...DEFAULT_SEO,
                openGraph: {
                    ...DEFAULT_SEO,
                    url: pageUrl,
                    images: [
                        {
                            ...DEFAULT_SEO.openGraph.images[0],
                            url: "".concat(pageUrl, "/tpc-logo-OG.webp"),
                            secureUrl: "".concat(pageUrl, "/tpc-logo-OG.webp")
                        }
                    ]
                }
            });
        }
    });
};
